import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { ProjectService } from './Services/project.service';

@Directive({
    selector: '[tooltipDirective]',
    standalone: false
})
export class TooltipDirectiveDirective {
  @Input('tooltip') tooltipTitle: string;
  @Input() placement: string;
  @Input() delay: any;
  @Input('tooltipDirective') tooltipDirective: any;
  tooltipData = []
  userList = [];
  tooltip: HTMLElement;
  currentTooltip: HTMLElement;
  offset = 10;
  constructor(private el: ElementRef, private renderer: Renderer2, private _projectService: ProjectService) {

  }

  @HostListener('click') onClick() {
    // Always hide any existing tooltip first
    const tooltipToHide = this.tooltip; // Capture potential existing tooltip
    if (tooltipToHide) {
      this.hide(); // Hide initiates removal but might be async
    }

    this.show(); // Creates a new tooltip element and sets this.tooltip

    this
      ._projectService
      .getUserList(0, 0).subscribe((user: any) => {
        this.userList = user;
        console.log(this.tooltipDirective, "this.tooltipDirective console")
        this._projectService.getAppUsageTooltipData(this.tooltipDirective.appName, this.tooltipDirective.star_date, this.tooltipDirective.end_date, this.tooltipDirective.type).subscribe((res: Array<any>) => {
          let userData: Array<any> = res;
          this.tooltipData = [];

          if (this.tooltipDirective.appName === "Others" && this.tooltipDirective.type === "website") {
            this.calculatingOthersTypeWebsiteTooltip(res);
          } else {
            for (let i = 0; i <= userData.length - 1; i++) {
              let obj = {
                user: this.displayUserName(userData[i].user_id),
                applicationUsage: this.convertIntoTime(userData[i].usageTime)
              }
              this.tooltipData.push(obj)
            }

            this.tooltipData.sort((a, b) => {
              const timeA = parseInt(a.applicationUsage.split(':')[0]) * 60 + parseInt(a.applicationUsage.split(':')[1]);
              const timeB = parseInt(b.applicationUsage.split(':')[0]) * 60 + parseInt(b.applicationUsage.split(':')[1]);
              return timeB - timeA;
            });
            // Ensure the DOM element exists before adding data (show() should handle this)
            // Also check if the current tooltip in the directive matches the one intended for the data
            if (this.tooltip && this.tooltip.textContent.includes(this.tooltipDirective.appName)) {
              this.addApplicationDataDiv();
            }
          }

        })
      })
  }
  convertIntoTime(selectedData) {
    const [hours, minutes, seconds] = selectedData.split(":").map(Number);
    // return `${this.padZeroes(hours)}:${this.padZeroes(minutes)}`;

    return `${this.padZeroes(hours)}:${this.padZeroes(minutes)}` + "h";
  }
  padZeroes(value: number) {
    return value.toString().padStart(2, '0');
  }
  displayUserName(id) {
    let resData = this.userList.filter((data: any) => {
      let userNameArr = data.name.split(" ");
      for (let i = 0; i < userNameArr.length; i++) {
        userNameArr[i] = userNameArr[i].charAt(0).toUpperCase() + userNameArr[i].slice(1);
      }
      data.name = userNameArr.join(" ");
      return data.id == id;
    });
    return resData.length ? resData[0].name : "";
  }
  getUserList() {
    this
      ._projectService
      .getUserList(0, 0).subscribe((user: any) => {
        this.userList = user;
      })
  }

  show() {
    if (document.getElementById('TooltipId')) {
      var existingTooltip = document.getElementById('TooltipId');
      existingTooltip.parentNode.removeChild(existingTooltip);
    }
    if (this.tooltipDirective.appName === "Others" && this.tooltipDirective.type === "website") {
      this.createElementForOthers();
    } else {
      this.create();
    }
    this.setPosition();
    this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
  }

  hide() {
    const tooltipElementToRemove = this.tooltip; // Capture the specific element reference when hide is called
    if (!tooltipElementToRemove) {
      return; // No tooltip element to hide
    }

    this.renderer.removeClass(tooltipElementToRemove, 'ng-tooltip-show');
    window.setTimeout(() => {
      // Only remove the element if it's still parented to the body (it might have been removed by show() already)
      if (tooltipElementToRemove.parentNode === document.body) {
        this.renderer.removeChild(document.body, tooltipElementToRemove);
      }
      // Crucially, only nullify the directive's main tooltip reference IF it still points
      // to the element we intended to remove. This prevents nullifying a newer tooltip
      // created by a subsequent show() call before this timeout finished.
      if (this.tooltip === tooltipElementToRemove) {
        this.tooltip = null;
      }
    }, this.delay || 0); // Use the provided delay, default to 0 if not set
  }

  create() {
    this.tooltip = this.renderer.createElement('div');
    this.currentTooltip = this.tooltip;
    this.tooltip.id = 'TooltipId'; // Set your desired ID here
    // this is for header part creating the headers for tooltip.
    let tooltipTitle = this.renderer.createElement('div');
    this.renderer.addClass(tooltipTitle, 'tooltip-title');
    let h3 = this.renderer.createElement('h6');
    this.renderer.appendChild(
      h3,
      this.renderer.createText(this.tooltipDirective.appName)
    );
    this.renderer.appendChild(
      tooltipTitle,
      h3
    );
    this.renderer.appendChild(
      this.tooltip,
      tooltipTitle
    );
    let tooltipHeader = this.renderer.createElement('div');
    this.renderer.addClass(tooltipHeader, 'tooltip-header');

    let innerDivOfTooltipHeader = this.renderer.createElement('div');
    let userTitle = this.renderer.createElement('h6');
    this.renderer.appendChild(
      userTitle,
      this.renderer.createText("Users")
    );
    let applicationUsageTitle = this.renderer.createElement('h6');

    this.renderer.appendChild(
      applicationUsageTitle,
      this.renderer.createText(`${this.tooltipDirective.type === "website" ? "Website Usage" : "Application Usage"}`)
    );
    this.renderer.appendChild(innerDivOfTooltipHeader, userTitle);
    this.renderer.appendChild(innerDivOfTooltipHeader, applicationUsageTitle);
    this.renderer.appendChild(tooltipHeader, innerDivOfTooltipHeader);
    this.renderer.appendChild(this.tooltip, tooltipHeader);


    let tooltipBody = this.renderer.createElement('div');
    tooltipBody.id = 'TooltipBodyId'; // Set your desired ID here

    this.renderer.addClass(tooltipBody, "tooltip-body");
    let innerDivOfTooltipBodyLoading = this.renderer.createElement('div');
    tooltipBody.id = 'TooltipBodyLoadingId'; // Set your desired ID here
    let LoadingTag = this.renderer.createElement('span');
    this.renderer.appendChild(
      LoadingTag,
      this.renderer.createText("Loading...")
    );
    this.renderer.appendChild(innerDivOfTooltipBodyLoading, LoadingTag);
    this.renderer.appendChild(tooltipBody, innerDivOfTooltipBodyLoading)

    this.renderer.appendChild(this.tooltip, tooltipBody);

    this.renderer.addClass(this.tooltip, 'ng-tooltip');
    this.renderer.addClass(this.tooltip, `ng-tooltip-${this.placement}`);
    this.renderer.setStyle(
      this.tooltip,
      '-webkit-transition',
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      '-moz-transition',
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      '-o-transition',
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      'transition',
      `opacity ${this.delay}ms`
    );
    this.renderer.appendChild(document.body, this.tooltip);

  }

  createElementForOthers() {
    this.tooltip = this.renderer.createElement('div');
    this.currentTooltip = this.tooltip;
    this.tooltip.id = 'TooltipId'; // Set your desired ID here
    let tooltipTitle = this.renderer.createElement('div');
    this.renderer.addClass(tooltipTitle, 'tooltip-title');
    let h3 = this.renderer.createElement('h6');
    this.renderer.appendChild(
      h3,
      this.renderer.createText(this.tooltipDirective.appName)
    );
    this.renderer.appendChild(
      tooltipTitle,
      h3
    );
    this.renderer.appendChild(
      this.tooltip,
      tooltipTitle
    );
    let tooltipHeader = this.renderer.createElement('div');
    this.renderer.addClass(tooltipHeader, 'tooltip-header');

    // this is for header part creating the headers for tooltip.
    let tooltipBody = this.renderer.createElement('div');
    tooltipBody.id = 'TooltipBodyId'; // Set your desired ID here


    this.renderer.addClass(tooltipBody, "tooltip-body");
    let innerDivOfTooltipBodyLoading = this.renderer.createElement('div');
    tooltipBody.id = 'TooltipBodyLoadingId'; // Set your desired ID here
    let LoadingTag = this.renderer.createElement('span');
    this.renderer.appendChild(
      LoadingTag,
      this.renderer.createText("Loading...")
    );
    this.renderer.appendChild(innerDivOfTooltipBodyLoading, LoadingTag);
    this.renderer.appendChild(tooltipBody, innerDivOfTooltipBodyLoading)
    this.renderer.appendChild(this.tooltip, tooltipBody);
    this.renderer.addClass(this.tooltip, 'ng-tooltip');
    this.renderer.addClass(this.tooltip, `ng-tooltip-${this.placement}`);
    this.renderer.setStyle(
      this.tooltip,
      '-webkit-transition',
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      '-moz-transition',
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      '-o-transition',
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      'transition',
      `opacity ${this.delay}ms`
    );
    this.renderer.appendChild(document.body, this.tooltip);
  }

  calculatingOthersTypeWebsiteTooltip(data: Array<Object>[]) {
    if (document.getElementById('TooltipBodyLoadingId')) {
      var existingTooltip = document.getElementById('TooltipBodyLoadingId');
      existingTooltip.parentNode.removeChild(existingTooltip);
      let tooltipBody = this.renderer.createElement('div');
      tooltipBody.id = 'TooltipBodyId'; // Set your desired ID here  
      this.renderer.addClass(tooltipBody, "tooltip-body");
      data.forEach((object: any) => {
        let innerDivOfTooltipBody = this.renderer.createElement('div');
        let windowNameTitle = this.renderer.createElement('h6');
        this.renderer.addClass(windowNameTitle, "window-name-title-tooltip")
        this.renderer.appendChild(windowNameTitle, this.renderer.createText(`${object.windowName}`));
        this.renderer.appendChild(innerDivOfTooltipBody, windowNameTitle);
        this.renderer.appendChild(tooltipBody, innerDivOfTooltipBody)
        let innerDivOfTooltipHeader = this.renderer.createElement('div');
        this.renderer.addClass(innerDivOfTooltipHeader, "tooltip-header-website")
        let userTitle = this.renderer.createElement('h6');
        this.renderer.appendChild(
          userTitle,
          this.renderer.createText("Users")
        );
        let applicationUsageTitle = this.renderer.createElement('h6');
        this.renderer.appendChild(
          applicationUsageTitle,
          this.renderer.createText("Website Usage")
        );
        this.renderer.appendChild(innerDivOfTooltipHeader, userTitle);
        this.renderer.appendChild(innerDivOfTooltipHeader, applicationUsageTitle);
        this.renderer.appendChild(tooltipBody, innerDivOfTooltipHeader);

        let rowUserWebsiteUsage = this.renderer.createElement("div");
        this.renderer.addClass(rowUserWebsiteUsage, "website-users-row")
        let usersSortedData = this.sortUserDataByTimeReverse(object["user_data"]);
        console.log("usersSortedData", usersSortedData)
        usersSortedData.forEach(element => {
          let usersElementSection = this.renderer.createElement("div");
          this.renderer.setStyle(usersElementSection, 'width', '100%');
          let websiteUser = this.renderer.createElement('p');
          let websiteUsage = this.renderer.createElement('p');
          this.renderer.addClass(websiteUsage, "website-usage-item")
          this.renderer.appendChild(
            websiteUser,
            this.renderer.createText(this.displayUserName(element.id))
          );
          this.renderer.appendChild(
            websiteUsage,
            this.renderer.createText(element.usage)
          );
          this.renderer.appendChild(usersElementSection, websiteUser);
          this.renderer.appendChild(usersElementSection, websiteUsage);
          this.renderer.appendChild(rowUserWebsiteUsage, usersElementSection)
        });
        this.renderer.appendChild(tooltipBody, rowUserWebsiteUsage);
        this.renderer.appendChild(this.tooltip, tooltipBody);
      })
    }
  }

  addApplicationDataDiv() {
    if (document.getElementById('TooltipBodyLoadingId')) {
      var existingTooltip = document.getElementById('TooltipBodyLoadingId');
      existingTooltip.parentNode.removeChild(existingTooltip);
      let tooltipBody = this.renderer.createElement('div');
      tooltipBody.id = 'TooltipBodyId'; // Set your desired ID here  
      this.renderer.addClass(tooltipBody, "tooltip-body");
      this.tooltipData.forEach((users: any) => {
        let innerDivOfTooltipBody = this.renderer.createElement('div');
        let applicationUser = this.renderer.createElement('p');
        let applicationUsage = this.renderer.createElement('p');
        this.renderer.appendChild(
          applicationUser,
          this.renderer.createText(users.user)
        );
        this.renderer.appendChild(
          applicationUsage,
          this.renderer.createText(users.applicationUsage)
        );
        this.renderer.appendChild(innerDivOfTooltipBody, applicationUser);
        this.renderer.appendChild(innerDivOfTooltipBody, applicationUsage);
        this.renderer.appendChild(tooltipBody, innerDivOfTooltipBody)
      });
      this.renderer.appendChild(this.tooltip, tooltipBody);
    }
  }

  sortUserDataByTimeReverse(userData) {
    let sortedData = [];
    for (let key in userData) {
      let obj = {
        id: key,
        usage: this.convertIntoTime(userData[key])
      };
      sortedData.push(obj)
    }
    sortedData.sort((a: any, b: any) => {
      const timeA = parseInt(a.usage.split(':')[0]) * 60 + parseInt(a.usage.split(':')[1]);
      const timeB = parseInt(b.usage.split(':')[0]) * 60 + parseInt(b.usage.split(':')[1]);
      return timeB - timeA;
    });


    return sortedData;
  }

  setPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();

    const tooltipPos = this.tooltip.getBoundingClientRect();
    const scrollPos =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    let top, left;

    if (this.placement === 'top') {
      top = hostPos.top - tooltipPos.height - this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.placement === 'bottom') {
      top = hostPos.bottom + this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.placement === 'left') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.left - tooltipPos.width - this.offset;
    }

    if (this.placement === 'right') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.right + this.offset;
    }


    this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
    this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
  }
}
